import { useState } from "react";
import WeightageModel from "../../model/WeightageModel";

export default function Luggage({ formData, setFormData, validationErrors, isWeightExceeded, setIsWeightExceeded }) {

  const [weightage, setWeightage] = useState({
    large: WeightageModel.large || 0,
    medium: WeightageModel.medium || 0,
    cabin: WeightageModel.cabin || 0,
    normal: WeightageModel.normal || 0
  });

  const [counts, setCounts] = useState({
    largeCount: formData.largeBag || 0,
    mediumCount: formData.mediumBag || 0,
    cabinCount: formData.cabinBag || 0
  });
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    let updatedLargeCount = counts.largeCount;
    let updatedMediumCount = counts.mediumCount;
    let updatedCabinCount = counts.cabinCount;

    if (name === 'largeBag') {
      updatedLargeCount = value;
    } else if (name === 'mediumBag') {
      updatedMediumCount = value;
    } else if (name === 'cabinBag') {
      updatedCabinCount = value;
    }

    setCounts((prevCounts) => ({
      ...prevCounts,
      largeCount: updatedLargeCount,
      mediumCount: updatedMediumCount,
      cabinCount: updatedCabinCount,
    }));

    const TotalWeight = updatedLargeCount * weightage.large +
      updatedMediumCount * weightage.medium +
      updatedCabinCount * weightage.cabin;


    const IsWeightExceeded = TotalWeight > weightage.normal;
    setIsWeightExceeded(IsWeightExceeded);
  };


  return (
    <div className="booking-step-luggage">
      <div className="heading">
        Select Luggage count details
      </div>
      <div className="inner-box">
        <div className="baggage">
          <img src="images/large-baggage-icon.png" alt="Large luggage" className="luggage-icon" />
          <div className="dimensions">
            <span>Height: 70-81 cm</span>
            <span>Width: 45-56 cm</span>
            <span>Depth: 25-38 cm</span>
          </div>
          <div className="bottom">
            <div className="baggage-text">LARGE BAGGAGE</div>
            <input
              type="number"
              autoComplete="off"
              id="largeBag"
              name="largeBag"
              min={0}
              onChange={handleChange}
              value={formData.largeBag}
              max={9}
              className={validationErrors.largeBag ? "input-error baggage-input" : "baggage-input"}
            />
          </div>
        </div>
        <div className="baggage">
          <img src="/images/medium-baggage-icon.png" alt="Medium luggage" className="luggage-icon" />
          <div className="dimensions">
            <span>Height: 60-69 cm</span>
            <span>Width: 40-50 cm</span>
            <span>Depth: 20-30 cm</span>
          </div>
          <div className="bottom">
            <div className="baggage-text">MEDIUM BAGGAGE</div>
            <input
              type="number"
              autoComplete="off"
              id="mediumBag"
              name="mediumBag"
              onChange={handleChange}
              value={formData.mediumBag}
              min={0}
              max={9}
              className={validationErrors.mediumBag ? "input-error baggage-input" : "baggage-input"}
            />
          </div>
        </div>
        <div className="baggage">
          <img src="/images/cabbin-baggage-icon.png" alt="Cabin luggage" className="luggage-icon" />
          <div className="dimensions">
            <span>Height: 45-55 cm</span>
            <span>Width: 35-40 cm</span>
            <span>Depth: 20-25 cm</span>
          </div>
          <div className="bottom">
            <div className="baggage-text">CABIN BAGGAGE</div>
            <input
              type="number"
              autoComplete="off"
              id="cabinBag"
              name="cabinBag"
              onChange={handleChange}
              value={formData.cabinBag}
              min={0}
              max={9}
              className={validationErrors.cabinBag ? "input-error baggage-input" : "baggage-input"}
            />
          </div>
        </div>
      </div>
      <div className="disclaimer">
        <p>Note: The above baggage measurements are approximate .</p>
      </div>
      {isWeightExceeded && (
        <p className="error-message">
          NOTE!! YOU HAVE EXCEEDED THE MAXIMUM LUGGAGE COUNT, KINDLY GO VIA THE KIOSK OR COUNT AT AIRPORT.
        </p>
      )}
    </div>
  )
}
